import React, { useContext, useState } from "react";
import styles from "./CustomerAddBlockPage.module.css";
import add from "./icons/add.svg";
import def from "./icons/default.svg";
import { redirectToPage } from "app/common/redirects/Redirects";
import { useNavigate } from "react-router-dom";
import API from "common-ui-components/components/utils/API";
import {
  Failure,
  Success,
} from "common-ui-components/components/notification/templates";
import { notify } from "common-ui-components/components/notification/Notification";
import { UserDetailsContext } from "App";
import Spinner from "common-ui-components/components/ResponseLoader/Spinner/Spinner";

const CustomerAddBlockPage = () => {
  const userDetails = useContext(UserDetailsContext);

  const [loading, setLoading] = useState(false);
  const history = useNavigate();

  const moveToAddCustomer = () => {
    redirectToPage(
      history,
      "/app/settings/organization/customers/new-customer",
    );
  };

  const handleDefaultCustomer = async () => {
    const formDataToSend = new FormData();
    const formDTO = {
      customerName: "Default Customer",
      description: "",
      primaryContactEmail: userDetails.ownerEmail,
      primaryContactPhone: "",
      domainName: "",
      country: "",
      timeZone: "",
      contactName: userDetails.name,
      licenseModel: "unlimited",
      deviceLimit: null,
      alertAt80: null,
      alertAt10: null,
    };
    formDataToSend.append(
      "customer",
      new Blob([JSON.stringify(formDTO)], { type: "application/json" }),
    );
    setLoading(true);
    try {
      const url = "/customer/addCustomer";
      const response = await API.post(url, formDataToSend);
      if (response.status.success) {
        notify(<Success>Default Customer created successfully</Success>);
        setTimeout(() => window.location.reload(), 1000);
      } else
        notify(
          <Failure>Default Customer creation failed. Please try again</Failure>,
        );
    } catch (error) {
      notify(<Failure>Customer creation failed. Please try again</Failure>);
      console.error("Error fetching in company details:", error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className={styles.overlay}>
      <div className={styles.popup}>
        <div className={styles.title}>Welcome to Zecurit MSP</div>

        <div className={styles.description}>
          Customers are tenants in your MSP workspace. Each customer has its own
          devices, policies, and license pool. How would you like to start?
        </div>

        <div className={styles.card}>
          <div
            className={styles.cardContent}
            onClick={() => moveToAddCustomer()}
          >
            <img src={add} alt={"Add"} width={60} height={60} />
            <div>
              <div className={styles.cardTitle}>
                Create my first customer now
              </div>
              <div className={styles.cardDesc}>
                Takes ~2 minutes. Add customer details and allocate licenses.
              </div>
            </div>
            <span className={styles.arrow}>›</span>
          </div>
        </div>

        <div className={styles.card}>
          <div
            className={styles.cardContent}
            onClick={() => handleDefaultCustomer()}
          >
            <img src={def} alt={"Default"} width={60} height={60} />
            <div>
              <div className={styles.cardTitle}>
                Use a Default customer for now
              </div>
              <div className={styles.cardDesc}>
                We'll create a "Default" customer. You can rename and configure
                it later.
              </div>
            </div>
            <span className={styles.arrow}>{loading ? <Spinner /> : "›"}</span>
          </div>
        </div>

        <div className={styles.footerText} onClick={() => moveToAddCustomer()}>
          You can always manage customers later from Settings → Customer
        </div>
      </div>
    </div>
  );
};

export default CustomerAddBlockPage;
